import { BrowserRouter, Routes, Route } from "react-router";
import { ThemeProvider } from "@/components/theme/theme-provider";
import { ROUTES } from "./constants/routeConstants";
import { AnonymLayout } from "./pages/shared/AnonymLayout";
import { AppLayout } from "./pages/shared/AppLayout";
// import { HomePage } from "./pages/dashboard/HomePage";
import { LoginPage } from "./pages/login/LoginPage";
import { ChangePasswordPage } from "./pages/ChangePasswordPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { AuditLogPage } from "./pages/AuditLogPage";
import { LoginLogPage } from "./pages/LoginLogPage";
import { TraceLogPage } from "./pages/TraceLogPage";
import { CurrencyPage } from "./pages/CurrencyPage";
import { ContentPage } from "./pages/content/ContentPage";
import { SplitContentDetailPage } from "./pages/contentSplit/SplitContentDetailPage";
import { ContentGroupPage } from "./pages/contentGroup/ContentGroupPage";
import { AddNewContentGroupPage } from "./pages/contentGroup/AddNewContentGroupPage";
import { ContentGroupDetailPage } from "./pages/contentGroup/ContentGroupDetailPage";
import { LinkedLicencesPage } from "./pages/linkedLicences/LinkedLicencesPage";
import { FirmTokenPage } from "./pages/FirmTokenPage";
import { FirmPage } from "./pages/firm/FirmPage";
import { AddNewFirmPage } from "./pages/firm/AddNewFirmPage";
import { FirmDetailPage } from "./pages/firm/firmDetail/FirmDetailPage";
import { RolePage } from "./pages/role/RolePage";
import { AddNewRolePage } from "./pages/role/AddNewRolePage";
import { UpdateRolePage } from "./pages/role/updateRole/UpdateRolePage";
import { MenuPage } from "./pages/menu/MenuPage";
import { AddNewMenuPage } from "./pages/menu/AddNewMenuPage";
import { MenuDetailPage } from "./pages/menu/updateMenu/MenuDetailPage";
import { AllergyPage } from "./pages/allergy/AllergyPage";
import { AddNewAllergyPage } from "./pages/allergy/AddNewAllergyPage";
import { AllergyDetailPage } from "./pages/allergy/updateAllergy/AllergyDetailPage";
import { StorePage } from "./pages/store/StorePage";
import { AddNewStorePage } from "./pages/store/AddNewStorePage";
import { StoreDetailPage } from "./pages/store/storeDetail/StoreDetailPage";
import { HospitalityMenuPage } from "./pages/hospitalityMenu/HospitalityMenuPage";
import { AddNewHospitalityMenuPage } from "./pages/hospitalityMenu/AddNewHospitalityMenuPage";
import { HospitalityMenuDetailPage } from "./pages/hospitalityMenu/hospitalityMenuDetail/HospitalityMenuDetailPage";
import { UserPage } from "./pages/user/UserPage";
import { AddNewUserPage } from "./pages/user/AddNewUserPage";
import { UserDetailPage } from "./pages/user/userDetail/UserDetailPage";
import { DSPage } from "./pages/ds/DSPage";
import { TemplateEditorPage } from "./pages/template/editor/TemplateEditorPage";
import { TemplatesPage } from "./pages/template/TemplatesPage";
import { AddNewTemplatePage } from "./pages/template/AddNewTemplatePage";
import { TemplateStockPage } from "./pages/templateStock/TemplateStockPage";
import { AddNewStockTemplatePage } from "./pages/templateStock/AddNewStockTemplatePage";
import { TemplateStockEditorPage } from "./pages/templateStock/editor/TemplateStockEditorPage";
import { TooltipProvider } from "@/components/ui/tooltip";
import { TagPage } from "./pages/tag/TagPage";
import { AddNewTagPage } from "./pages/tag/AddNewTagPage";
import { UpdateTagPage } from "./pages/tag/updateTag/UpdateTagPage";
import { ScreenSizePage } from "./pages/screenSize/ScreenSizePage";
import { AddNewScreenSizePage } from "./pages/screenSize/AddNewScreenSizePage";
import { ScreenSizeDetailPage } from "./pages/screenSize/playerScreenSizeDetail/ScreenSizeDetailPage";
import { PlayerPage } from "./pages/player/PlayerPage";
import { ChannelPage } from "./pages/channel/ChannelPage";
import { AddNewChannelPage } from "./pages/channel/AddNewChannelPage";
import { ChannelDetailPage } from "./pages/channel/channelDetail/ChannelDetailPage";
import { AddNewPlayerPage } from "./pages/player/AddNewPlayerPage";
import { PlayerDetailPage } from "./pages/player/playerDetail/PlayerDetailPage";
import { AreaPage } from "./pages/area/AreaPage";
import { AreaMobilePage } from "./pages/area/AreaMobilePage";
import { HomePage } from "./pages/dashboard/HomePage";
import { CampaignPage } from "./pages/campaign/CampaignPage";
import { AddNewCampaignPage } from "./pages/campaign/AddNewCampaignPage";
import { CampaignDetailPage } from "./pages/campaign/campaignDetail/CampaignDetailPage";
import { AreaTypePage } from "./pages/areaType/AreaTypePage";
import { AddNewAreaTypePage } from "./pages/areaType/AddNewAreaTypePage";
import { AreaTypeDetailPage } from "./pages/areaType/areaTypeDetail/AreaTypeDetailPage";
import { SettingsPage } from "./pages/SettingsPage";
import { MenuHeaderPage } from "./pages/menuHeader/MenuHeaderPage";
import { AddNewMenuHeaderPage } from "./pages/menuHeader/AddNewMenuHeaderPage";
import { MenuHeaderDetailPage } from "./pages/menuHeader/updateMenu/MenuHeaderDetailPage";
import { DSSettingsPage } from "./pages/ds/DSSettings";
import { AddNewBlogPostPage } from "./pages/blogPost/AddNewBlogPostPage";
import { BlogPostPage } from "./pages/blogPost/BlogPostPage";
import { BlogPostDetailPage } from "./pages/blogPost/updateBlogPost/BlogPostDetailPage";
import { SplitContentDetailMobilePage } from "./pages/contentSplit/SplitContentDetailMobilePage";
import { AddNewUserSubAdminPage } from "./pages/userSubAdmin/AddNewUserSubAdminPage";
import { UserSubAdminDetailPage } from "./pages/userSubAdmin/UserSubAdminDetailPage";
import { UserSubAdminPage } from "./pages/userSubAdmin/UserSubAdminPage";
import { ReportPage } from "./pages/report/ReportPage";
import { ContentGroupMemberCategoryPage } from "./pages/contentGroupMemberCategory/ContentGroupMemberCategoryPage";
import { AddNewContentGroupMemberCategoryPage } from "./pages/contentGroupMemberCategory/AddNewContentGroupMemberCategoryPage";
import { UpdateContentGroupMemberCategoryPage } from "./pages/contentGroupMemberCategory/updateTag/UpdateContentGroupMemberCategoryPage";

function App() {
  return (
    <>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <TooltipProvider delayDuration={0}>
          <BrowserRouter>
            <Routes>
              <Route element={<AppLayout />}>
                <Route path={ROUTES.HOME} element={<HomePage />} />
                <Route path={ROUTES.CHANGE_PASSWORD} element={<ChangePasswordPage />} />
                <Route path={ROUTES.AUDIT_LOG} element={<AuditLogPage />} />
                <Route path={ROUTES.LOGIN_LOG} element={<LoginLogPage />} />
                <Route path={ROUTES.TRACE_LOG} element={<TraceLogPage />} />
                <Route path={ROUTES.CURRENCY} element={<CurrencyPage />} />
                <Route path={ROUTES.CONTENT} element={<ContentPage />} />
                <Route path={ROUTES.CONTENT_SPLIT_DETAIL} element={<SplitContentDetailPage />} />
                <Route path={ROUTES.CONTENT_GROUP} element={<ContentGroupPage />} />
                <Route path={ROUTES.CONTENT_GROUP_ADD} element={<AddNewContentGroupPage />} />
                <Route path={ROUTES.CONTENT_GROUP_DETAIL} element={<ContentGroupDetailPage />} />
                <Route path={ROUTES.CONTENT_GROUP_MEMBER_CATEGORY} element={<ContentGroupMemberCategoryPage />} />
                <Route
                  path={ROUTES.CONTENT_GROUP_MEMBER_CATEGORY_ADD}
                  element={<AddNewContentGroupMemberCategoryPage />}
                />
                <Route
                  path={ROUTES.CONTENT_GROUP_MEMBER_CATEGORY_DETAIL}
                  element={<UpdateContentGroupMemberCategoryPage />}
                />
                <Route path={ROUTES.LINKED_LicenceS} element={<LinkedLicencesPage />} />
                <Route path={ROUTES.FIRM_TOKEN} element={<FirmTokenPage />} />
                <Route path={ROUTES.ROLE} element={<RolePage />} />
                <Route path={ROUTES.ROLE_ADD} element={<AddNewRolePage />} />
                <Route path={ROUTES.ROLE_DETAIL} element={<UpdateRolePage />} />
                <Route path={ROUTES.MENU} element={<MenuPage />} />
                <Route path={ROUTES.MENU_ADD} element={<AddNewMenuPage />} />
                <Route path={ROUTES.MENU_DETAIL} element={<MenuDetailPage />} />
                <Route path={ROUTES.MENU_HEADER} element={<MenuHeaderPage />} />
                <Route path={ROUTES.MENU_HEADER_ADD} element={<AddNewMenuHeaderPage />} />
                <Route path={ROUTES.MENU_HEADER_DETAIL} element={<MenuHeaderDetailPage />} />
                <Route path={ROUTES.ALLERGY} element={<AllergyPage />} />
                <Route path={ROUTES.ALLERGY_ADD} element={<AddNewAllergyPage />} />
                <Route path={ROUTES.ALLERGY_DETAIL} element={<AllergyDetailPage />} />
                <Route path={ROUTES.STORE} element={<StorePage />} />
                <Route path={ROUTES.STORE_ADD} element={<AddNewStorePage />} />
                <Route path={ROUTES.STORE_DETAIL} element={<StoreDetailPage />} />
                <Route path={ROUTES.HOSPITALITY_MENU} element={<HospitalityMenuPage />} />
                <Route path={ROUTES.HOSPITALITY_MENU_ADD} element={<AddNewHospitalityMenuPage />} />
                <Route path={ROUTES.HOSPITALITY_MENU_DETAIL} element={<HospitalityMenuDetailPage />} />
                <Route path={ROUTES.USER} element={<UserPage />} />
                <Route path={ROUTES.USER_ADD} element={<AddNewUserPage />} />
                <Route path={ROUTES.USER_DETAIL} element={<UserDetailPage />} />
                <Route path={ROUTES.FIRM} element={<FirmPage />} />
                <Route path={ROUTES.FIRM_ADD} element={<AddNewFirmPage />} />
                <Route path={ROUTES.FIRM_DETAIL} element={<FirmDetailPage />} />
                <Route path={ROUTES.TEMPLATES} element={<TemplatesPage />} />
                <Route path={ROUTES.TEMPLATE_EDITOR} element={<TemplateEditorPage />} />
                <Route path={ROUTES.TEMPLATE_ADD} element={<AddNewTemplatePage />} />
                <Route path={ROUTES.TEMPLATE_STOCK} element={<TemplateStockPage />} />
                <Route path={ROUTES.TEMPLATE_STOCK_ADD} element={<AddNewStockTemplatePage />} />
                <Route path={ROUTES.TEMPLATE_STOCK_EDITOR} element={<TemplateStockEditorPage />} />
                <Route path={ROUTES.TAG} element={<TagPage />} />
                <Route path={ROUTES.TAG_ADD} element={<AddNewTagPage />} />
                <Route path={ROUTES.TAG_DETAIL} element={<UpdateTagPage />} />
                <Route path={ROUTES.SCREEN_SIZE} element={<ScreenSizePage />} />
                <Route path={ROUTES.SCREEN_SIZE_ADD} element={<AddNewScreenSizePage />} />
                <Route path={ROUTES.SCREEN_SIZE_DETAIL} element={<ScreenSizeDetailPage />} />
                <Route path={ROUTES.PLAYER} element={<PlayerPage />} />
                <Route path={ROUTES.PLAYER_ADD} element={<AddNewPlayerPage />} />
                <Route path={ROUTES.PLAYER_DETAIL} element={<PlayerDetailPage />} />
                <Route path={ROUTES.CHANNEL} element={<ChannelPage />} />
                <Route path={ROUTES.CHANNEL_ADD} element={<AddNewChannelPage />} />
                <Route path={ROUTES.CHANNEL_DETAIL} element={<ChannelDetailPage />} />
                <Route path={ROUTES.AREA} element={<AreaPage />} />
                <Route path={ROUTES.AREA_TYPE} element={<AreaTypePage />} />
                <Route path={ROUTES.AREA_TYPE_ADD} element={<AddNewAreaTypePage />} />
                <Route path={ROUTES.AREA_TYPE_DETAIL} element={<AreaTypeDetailPage />} />
                <Route path={ROUTES.CAMPAIGN} element={<CampaignPage />} />
                <Route path={ROUTES.CAMPAIGN_ADD} element={<AddNewCampaignPage />} />
                <Route path={ROUTES.CAMPAIGN_DETAIL} element={<CampaignDetailPage />} />
                <Route path={ROUTES.SETTINGS} element={<SettingsPage />} />
                <Route path={ROUTES.BLOG_POST} element={<BlogPostPage />} />
                <Route path={ROUTES.BLOG_POST_ADD} element={<AddNewBlogPostPage />} />
                <Route path={ROUTES.BLOG_POST_DETAIL} element={<BlogPostDetailPage />} />
                <Route path={ROUTES.USER_SUB_ADMIN} element={<UserSubAdminPage />} />
                <Route path={ROUTES.USER_SUB_ADMIN_ADD} element={<AddNewUserSubAdminPage />} />
                <Route path={ROUTES.USER_SUB_ADMIN_DETAIL} element={<UserSubAdminDetailPage />} />
                <Route path={ROUTES.REPORT} element={<ReportPage />} />
                <Route path="*" element={<NoMatch />} />
              </Route>
              <Route element={<AnonymLayout />}>
                <Route path={ROUTES.LOGIN} element={<LoginPage />} />
                <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
              </Route>
              {/* Mobile accessible routes */}
              <Route path={ROUTES.AREA_MOBILE} element={<AreaMobilePage />} />
              <Route path={ROUTES.CONTENT_SPLIT_DETAIL_MOBILE} element={<SplitContentDetailMobilePage />} />
              {/* DS */}
              <Route path={ROUTES.DS} element={<DSPage />} />
              <Route path={ROUTES.DS_SETTINGS} element={<DSSettingsPage />} />
              {/* 404 */}
              <Route path="*" element={<NoMatch />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </ThemeProvider>
    </>
  );
}

const NoMatch = () => {
  return <div>Page not found</div>;
};

export default App;
